import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Figure } from "@/components/bloks/Media/components/Figure";
import { Container } from "@/components/ui/Container";
import type { DualMediaStoryblok } from "@/generated/sb/sb-types";

export const DualMediaBlok = ({ blok }: BlokProps<DualMediaStoryblok>) => {
	const variant = blok.variant || "default";

	const Content = () => {
		if (variant === "asymmetric") {
			return (
				<div className="grid grid-cols-4 gap-grid-component-spacing-md md:grid-cols-2 md:grid-rows-2">
					{blok.asset1 && (
						<Figure
							asset={blok.asset1}
							containerClassName="col-span-4 row-start-1 md:col-span-1 md:col-start-2 md:row-span-2"
							mediaClassName="aspect-3/4"
						/>
					)}
					{blok.asset2 && (
						<Figure
							asset={blok.asset2}
							containerClassName="col-span-4 row-start-2 md:col-span-1 md:col-start-1 md:row-start-1"
							mediaClassName="aspect-3/2"
						/>
					)}
				</div>
			);
		}

		return (
			<div className="flex flex-col gap-grid-component-spacing-md md:grid md:grid-cols-2">
				<Figure asset={blok.asset1} mediaClassName="aspect-square md:aspect-3/4" />
				<Figure asset={blok.asset2} mediaClassName="aspect-square md:aspect-3/4" />
			</div>
		);
	};

	return (
		<BlokWrap editable={blok} className="pb-grid-section-vertical-md">
			{blok.fullWidth ? (
				<Content />
			) : (
				<Container>
					<Content />
				</Container>
			)}
		</BlokWrap>
	);
};
